import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import FJEmptyUploadButtonClass from '../../../../commonClass/FJEmptyUploadButtonClass.jsx';
import classNames from 'classnames';
import styles from './FJUploadButtonContainer.module.less';
import { setSliceIsDraggingFileAction } from '../../../../../redux/slices/FJSliceCommon.js';
import FJInputUtil from '../../../../../util/FJInputUtil.js';
import FJActionTextBasedEditing from '../../../../../redux/action/textBasedEditing/FJActionTextBasedEditing.js';
import FJLoading from '../../../../../common/components/FJLoading/FJLoading.jsx';
import FJUploadBorderIcon from '../../../../../assets/svg/upload-border-normal.svg?react';

const button = new FJEmptyUploadButtonClass({ text: 'upload-video-or-audio' });

const accept =
    '.mp4, .mov, .webm, .m4v, .avi, .wmv, .mkv, .rmvb, .mpg, .mpeg, .flv, .rm, .mp3, .wma, .aac, .wav, .m4a, .oga, .weba, .ogg, .flac';

const FJUploadButtonContainer = () => {
    const dispatch = useDispatch();
    const isDraggingFile = useSelector(state => state.common.isDraggingFile);
    const isLoadingResource = useSelector(state => state.textBasedEditing.isLoadingResource);

    const _setIsDraggingFile = value => {
        dispatch(setSliceIsDraggingFileAction(value));
    };

    const _onClick = () => {
        FJInputUtil.createInput(accept, e => {
            const file = e.target.files[0];
            _onUpload(file);
        });
    };

    const _onUpload = file => {
        dispatch(FJActionTextBasedEditing.uploadFileAction(file));
    };

    const _onDragOver = e => {
        _setIsDraggingFile(true);
        e.stopPropagation();
        e.preventDefault();
    };

    const _onDragLeave = e => {
        _setIsDraggingFile(false);
        e.stopPropagation();
        e.preventDefault();
    };

    const _onDragDrop = e => {
        _setIsDraggingFile(false);
        e.stopPropagation();
        e.preventDefault();
        let files = e.dataTransfer.files;
        if (files && files.length > 0) {
            const file = files[0];
            _onUpload(file);
        }
    };

    if (isLoadingResource)
        return (
            <div className={styles.loading_box}>
                <FJLoading strokeColor='#A8ACBC' />
                <FJUploadBorderIcon className={styles.upload_border} />
            </div>
        );
    else
        return (
            <div
                className={classNames(styles.box, { [styles.dragging]: isDraggingFile })}
                onDragOver={_onDragOver}
                onDragLeave={_onDragLeave}
                onDrop={_onDragDrop}
            >
                {button.render({ onClick: _onClick, isDraggingFile: isDraggingFile })}
            </div>
        );
};

export default FJUploadButtonContainer;
